import theme_dark from './theme_dark';

export default {
  colors: {
    ...theme_dark.colors,
    primary: '#15a118',
    primary_light: 'rgba(23, 183, 15, 0.2)',
    red_light: 'rgba(225, 160, 154, 0.22)',
    dark_shadow: 'rgba(255,255,255,0.5)',
    sutil_shadow: 'rgba(255,255,255,0.08)',
    carousel_dot_active: '#15a118',
    carousel_dot_inactive: 'rgba(255, 255, 255, 0.2)',
    profile_background: '#222',
    profile_initials: '#FFF',
    profile_background_reverse: '#FFF',
    profile_initials_reverse: '#222',
    header_icon_background: 'rgba(255, 255, 255, 0.044)',
    header_icon_color: '#FFF',
    button_secondary: '#383838',
    card_menu_active: '#283B1E',
    home_services_fuel_bg: '#283B1E',
    home_services_fuel_pulse: '#1ac11d',
    home_services_vantagens_bg: 'rgba(212, 175, 55, 0.18)',
    home_services_vantagens_icon: '#E0C15A',
    home_services_vantagens_text: '#F5E6C8',
    home_services_vantagens_border: '#D4AF37',
    home_services_vantagens_gradient: [
      '#2A2410',
      '#3D3212',
      '#4D3E10',
      '#2E2712',
    ],
    info_bg: 'rgba(56, 138, 221, 0.18)',
    info_icon: '#7FB2EA',
    achievements_bg: '#ffb11539',
    achievements_color: '#FFB115',
    coupon_card_border: 'rgba(22, 163, 74, 0.22)',
    coupon_card_shadow: 'rgba(22, 163, 74, 0.08)',
    coupon_card_shadow_ios: 'rgba(148, 225, 197, 0.25)',
    carrinho_progress_border: 'rgba(255, 149, 20, 0.35)',
    carrinho_progress_shadow: 'rgba(255, 149, 0, 0.3)',
    coupon_gold_gradient: ['#2E2712', '#3A3013', '#463912', '#332B14'],
    coupon_silver_gradient: ['#2A2B2E', '#33353A', '#3D4045', '#2E3034'],
    coupon_category_ouro_border: '#eec84a64',
    coupon_category_ouro_icon: '#C99C39',
    coupon_category_ouro_action_bg: '#eec84a',
    coupon_category_ouro_action_text: '#FFF',
    coupon_category_prata_border: '#BBC3CA',
    coupon_category_prata_icon: '#9EA7AD',
    coupon_category_prata_action_bg: '#9EA7AD',
    coupon_category_prata_action_text: '#fff',
    coupon_category_default_border: '#E87722',
    coupon_category_default_icon: '#E87722',
    coupon_category_default_action_bg: '#17B70F',
    coupon_category_default_action_text: '#FFF',
    coupon_badge_ouro_bg: '#3A2E00',
    coupon_badge_ouro_text: '#E8AE4D',
    coupon_badge_ouro_border: '#C99C39',
    coupon_badge_prata_bg: '#2D2D2D',
    coupon_badge_prata_text: '#9EA7AD',
    coupon_badge_prata_border: '#555C63',
  },

  fonts: {
    light: 'Poppins-Light',
    regular: 'Poppins-Regular',
    medium: 'Poppins-Medium',
    semibold: 'Poppins-SemiBold',
    bold: 'Poppins-Bold',
    fuel: 'OpenSans-ExtraBoldItalic',
  },

  mapstyle: [
    {
      elementType: 'geometry',
      stylers: [
        {
          color: '#1a1a1a',
        },
      ],
    },
    {
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#757575',
        },
      ],
    },
    {
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#1a1a1a',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry',
      stylers: [
        {
          color: '#757575',
        },
      ],
    },
    {
      featureType: 'administrative.country',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#9e9e9e',
        },
      ],
    },
    {
      featureType: 'administrative.land_parcel',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#bdbdbd',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#757575',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [
        {
          color: '#0f1f0e',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#616161',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#1b1b1b',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#2c2c2c',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#8a8a8a',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry',
      stylers: [
        {
          color: '#373737',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [
        {
          color: '#3c3c3c',
        },
      ],
    },
    {
      featureType: 'road.highway.controlled_access',
      elementType: 'geometry',
      stylers: [
        {
          color: '#4e4e4e',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#616161',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#757575',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [
        {
          color: '#000000',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#3d3d3d',
        },
      ],
    },
  ],
};
